// extracted by mini-css-extract-plugin
module.exports = {"cell":"UpdatedCell_cell__2iiex"};